import React from 'react'
import FocusLock from 'react-focus-lock'

import './style.scss'

import ModalHeader from './header'
import ModalFooter from './footer'
import ModalContent from './content'
import ModalBackdrop from './backdrop'

import Portal from '../../styled-base/portal'

import { useOnClickOutside } from '../../hooks/useOnClickOutside'

const noop = () => {}

const getInitialPosition = () => ({
  x: '50%',
  y: '50%'
})

const ModalArticle = React.forwardRef(({
  className,
  children,
  id,
  style,
  labelledBy,
  onClose
}, ref) =>(
  <div 
    role="dialog"
    aria-modal="true"
    aria-labelledby={labelledBy}
    onKeyUp={e => e.key === 'Escape' && onClose(e)}
  >
    <article
      ref={ref}
      style={style}
      className={className}
      id={id}
      tabIndex={0}
    >
      { children }
    </article>
  </div>
))

export default function VeryNiceModal ({
  children,
  persist = true, // No backdrop. No click to close.
  position = getInitialPosition(),
  onClose = noop,
  width = 400,
  style = {},
  transform_property = false,
  transform_property_lm = false,
  classes = '',
  id= '',
  disableFocusLock=true,
  disableClickOutside = false,
  labelledBy = ''}) {
  const [ref] = useOnClickOutside(!disableClickOutside && onClose); // TODO: Doesn't handle nested modals.

  let conditionalClass = ['portal-modal'];
  if(transform_property && transform_property_lm) {
    conditionalClass.push('transform_property_lm');
  } else {
    if (transform_property) {
      conditionalClass.push('transform_property');
    }
    if (classes) {
      conditionalClass.push(classes);
    }
  }
  return (
    <>
    <FocusLock
      shards={[ref]}
      disabled={disableFocusLock}
    >
      <Portal
        isFixed
        position={position}
      >
        {persist && <ModalBackdrop />}
        <ModalArticle
          ref={ref}
          className={conditionalClass.join(' ')}
          id={id}
          style={{ width, ...style }}
          labelledBy={labelledBy}
          onClose={onClose}
        >
          { children }
        </ModalArticle>
      </Portal>
    </FocusLock>
    </>
  )
}

VeryNiceModal.Header = ModalHeader
VeryNiceModal.Footer = ModalFooter
VeryNiceModal.Article = ModalArticle
VeryNiceModal.Content = ModalContent
VeryNiceModal.Backdrop = ModalBackdrop